module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/general-transaction/general-transaction.component.css
// module id = ./src/app/general-transaction/general-transaction.component.css
// module chunks = main